import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RendezVousPage from './pages/RendezVousPage';
import StatisticsPage from './pages/StatisticsPage';
import ProspectDetailPage from './pages/ProspectDetailPage';
import AgendaDisplayPage from './pages/AgendaDisplayPage';
import Utilisateurs from './components/Utilisateurs';
import SettingsPage from './pages/SettingsPage';
import './App.css';

// Ce composant protège les routes
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Ce composant gère la redirection si l'utilisateur est déjà connecté
const LoginPageWrapper = () => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return <LoginPage />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPageWrapper />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/a-traiter" element={<HomePage />} />
                  <Route path="/plus-tard" element={<HomePage />} />
                  <Route path="/rendez-vous" element={<HomePage />} />
                  <Route path="/mes-leads" element={<HomePage />} /> {/* Nouvelle route pour les leads du fournisseur */}
                  <Route path="/agenda" element={<AgendaDisplayPage />} />
                  <Route path="/utilisateurs" element={<Utilisateurs />} />
                  <Route path="/parametres" element={<SettingsPage />} />
                  <Route path="/prospect/:id" element={<ProspectDetailPage />} />
                  <Route path="/statistiques" element={<StatisticsPage />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App; 